export default {
  labels: {
    selectOne: '1つのオプションを選択してください',
    selectAll: '該当するすべてを選択してください',
    typeResponse: '以下のテキストボックスに回答を入力してください。',
    recordResponse: '質問に答えるために録画を行ってください。',
    enterNumeric: '以下のフィールドに数値を入力してください。',
    rateResponseScale: '提供されたスケールで回答を評価してください。',
    sliderMinimum: '最小値：{value}',
    sliderMaximum: '最大値：{value}',
    selectOneOptionRow: '各行で1つのオプションを選択してください。',
    selectAllOptionsRow: '各行で該当するすべてのオプションを選択してください。',
    dragAndDropResponse: '好みの順に並べるためにオプションをドラッグ＆ドロップしてください。',
    rankOrderDesktopInstruction: 'アイテムをドラッグ＆ドロップして順位付けするか、+ボタンでリストに追加してください。矢印ボタンで並び替え、削除ボタンで削除できます。',
    alert: "警告",
    error: '{min} から {max} までの数値を入力してください。',
    cameras: 'カメラ',
    microphones: 'マイク',
    recording: '録画',
    noDevicesFound: 'デバイスが見つかりません',
    camera: 'カメラ',
    microphone: 'マイク',
    stopRecording: '録画を停止',
    startRecording: '録画を開始',
    disableCamera: 'カメラを無効にする',
    enableCamera: 'カメラを有効にする',
    disableMicrophone: 'マイクを無効にする',
    enableMicrophone: 'マイクを有効にする',
    settings: '設定',
    recordingProgress: '録画進行状況',
    playbackProgress: '再生進行状況',
    play: '再生',
    pause: '一時停止',
    stop: '停止',
    record: '録画',
    recordAgain: 'もう一度録画',
    retry: '再試行',
    done: '完了',
    minRecordTime: '回答を{min}秒間録画してください。',
    enlargeImage: '画像を拡大',
    enlargedImage: '拡大した画像',
    close: '閉じる',
    zoomIn: '拡大',
    zoomOut: '縮小',
    resetZoom: 'ズームをリセット',
    zoomLevel: 'ズーム {percentage}%',
    imagePosition: '{current} / {total}',
    previousImage: '前の画像',
    nextImage: '次の画像',
    imageLoading: '画像を読み込み中',
    imageLoadFailed: '画像を読み込めませんでした',
  },
  noSelection: "選択なし",
  actions: {
    increase: '増加',
    decrease: '減少'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'アンケートプレビュー終了',
      titleCompleted: 'アンケートプレビュー完了',
      previewModeWarning: 'このページはプレビューモードでのみ表示され、実際の回答者には表示されません。',
      reachedEndPoint: 'このアンケートは終了地点に達しました。',
      reachedEndPointCompleted: 'このプレビューは終了地点に達しました。',
      returnToModify: '前の質問に戻って回答を変更し、別のアンケートパスをテストしてください。',
      logic: 'ロジック'
    }  }
}
